import ReactAudioPlayer from '../ReactAudioPlayer';
import GlobalAudioPlayer from '../GlobalAudioPlayer';
import { useParams, usePathname } from 'next/navigation';
import useAudioPlayer from '@/context/audioPlayer/useAudioPlayer';
import { useEffect, useState } from 'react';

function GlobalAudioPlayerContainer({ className }) {
    const { id: currentlyPlayingAudioId } = useAudioPlayer();
    const pathname = usePathname();
    const { id } = useParams();

    const [hide, setHide] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            // TODO: change this to the way we handle hobe
            setHide(
                !(
                    pathname === '/' ||
                    pathname === '/profile' ||
                    pathname.includes('/bookmarks') ||
                    pathname.includes('/community') ||
                    (id && pathname.includes('/audio'))
                ) || !currentlyPlayingAudioId
            );
        }, 0);
    }, [pathname, currentlyPlayingAudioId]);

    // todo: add some good transitions and animations to this
    return (
        <div className={className}>
            <ReactAudioPlayer id={currentlyPlayingAudioId} />
            <GlobalAudioPlayer isHidden={hide} id={currentlyPlayingAudioId} />
        </div>
    );
}

export default GlobalAudioPlayerContainer;